import { useState } from "react";
import { Navigate, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      await login(email, password);
      nav("/admin");
    } catch (er) {
      setError(errMsg(er));
    } finally {
      setBusy(false);
    }
  };

  return (
    <main className="min-h-screen grid place-items-center px-5 bg-[#FBFBFB]" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm border border-[#0F0F0F] bg-white p-8 space-y-5 shadow-[6px_6px_0_0_#0033FF]">
        <span className="tag text-[#0033FF]">Area riservata · Admin</span>
        <h1 className="font-display font-black text-3xl tracking-tight">Accedi</h1>
        <input data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" className="field" />
        <input data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" className="field" />
        {error && <p className="text-sm text-[#FF3333]" data-testid="admin-login-error">{error}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="btn-primary w-full h-11 !bg-[#0033FF] hover:!bg-[#0022AA]">
          {busy ? "Accesso..." : "Entra"}
        </button>
      </form>
    </main>
  );
}
